import { useState } from "react";
import axios, { AxiosError } from "axios";

interface BankDetails {
  bankName: string;
  accountHolderName: string;
  accountNo: string;
  iban: string;
}

export interface PatchBankDetailsPayload {
  bankDetails: BankDetails;
}

interface UsePatchReturn<T> {
  patchData: (url: string, payload: T) => Promise<any>;
  loading: boolean;
  error: string | null;
  data: any;
}

export const usePatch = <T = any>(): UsePatchReturn<T> => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);

  const patchData = async (url: string, payload: T) => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.patch(url, payload);

      setData(response.data);
      return response.data;
    } catch (err) {
      const error = err as AxiosError<any>;
      setError(error.response?.data?.message || "Something went wrong");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { patchData, loading, error, data };
};